<div class="form-group d-flex justify-content-between align-items-center" [ngClass]="{'primary-bg': primaryBackground}">
  <label class="fw-bold">{{message}}</label>
  <label class="custom-switch">
    <input type="checkbox" 
          [checked]="isChecked" 
          [disabled]="readonly"
          (change)="toggleSwitch()">
    <span class="slider round">
      <span class="switch-text yes">Yes</span>
      <span class="switch-text no">No</span>
    </span>
  </label>  
</div>